import * as types from '../types/adTypes';

const initialState = {
  placements: {},
  loadingByKey: {},
  errorByKey: {},
};

const adReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_AD_PLACEMENT_REQUEST: {
      const key = action.meta.key;
      return {
        ...state,
        loadingByKey: { ...state.loadingByKey, [key]: true },
        errorByKey: { ...state.errorByKey, [key]: null },
      };
    }
    case types.FETCH_AD_PLACEMENT_SUCCESS: {
      const key = action.meta.key;
      const list = Array.isArray(action.payload) ? action.payload : [];
      return {
        ...state,
        placements: { ...state.placements, [key]: list },
        loadingByKey: { ...state.loadingByKey, [key]: false },
        errorByKey: { ...state.errorByKey, [key]: null },
      };
    }
    case types.FETCH_AD_PLACEMENT_FAILURE: {
      const key = action.meta.key;
      return {
        ...state,
        loadingByKey: { ...state.loadingByKey, [key]: false },
        errorByKey: { ...state.errorByKey, [key]: action.payload },
      };
    }
    case types.TRACK_AD_EVENT_REQUEST:
    case types.TRACK_AD_EVENT_SUCCESS:
    case types.TRACK_AD_EVENT_FAILURE:
    default:
      return state;
  }
};

export default adReducer;
